module.exports = __webpack_public_path__ + "static/media/mail-message-default-overlay.984c98ca.png";